import {
    ICustomerCreate,
    ICustomerUpdate,
    IPerson,
    IPersonCreate,
    IPersonFormData,
    IPersonUpdate,
} from '../typing/person.interface';
import { DaysKey } from '../typing/schedule-params.interface';
import { Role } from '../enums/role.enum';

export class Person {
    data: IPerson;

    constructor(data: IPerson) {
        this.data = data;
    }

    dataForUpdateCoordinates(lat: number, lon: number): IPersonUpdate {
        return {
            id: this.data.id,
            lat: lat,
            lon: lon
        };
    }

    updateData(data: IPerson): void {
        this.data = {
            ...this.data,
            ...data,
        };
    }

    dataForUpdatePaymentDeviceSn(paymentDeviceId: string): IPersonUpdate {
        return {
            id: this.data.id,
            paymentDeviceSn: paymentDeviceId,
        };
    };

    dataForCreate(formData: IPersonFormData): IPersonCreate {
        return {
            firstName: formData.firstName,
            role: formData.role,
            lastName: formData.lastName,
            login: formData.login,
            password: formData.password || null,
            phone: formData.phone,
            groupId: formData.groupId,
            scheduleParams: this.data.scheduleParams,
            managesGroupsIds: formData.managesGroupsIds?.[0] ? formData.managesGroupsIds : []
        };
    }

    dataForUpdate(formData: IPersonFormData): IPersonUpdate {
        return {
            id: this.data.id,
            firstName: formData.firstName,
            role: formData.role,
            lastName: formData.lastName,
            login: formData.login,
            password: formData.password || null,
            phone: formData.phone,
            groupId: formData.groupId,
            scheduleParams: this.data.scheduleParams,
            managesGroupsIds: formData.managesGroupsIds?.[0] ? formData.managesGroupsIds : [],
        };
    }

    formData(): IPersonFormData {
        return {
            firstName: this.data.firstName,
            lastName: this.data.lastName,
            groupId: this.data.group?.id || null,
            role: this.data.role,
            login: this.data.login,
            phone: this.data.phone,
            password: '',
            managesGroupsIds: this.data.managesGroups?.map(group => group.id) || []
        };
    }

    dataForCustomerUpdate(formData: ICustomerUpdate): ICustomerUpdate {
        return {
            id: this.data.id,
            firstName: formData.firstName,
            lastName: formData.lastName,
            phone: formData.phone,
        };
    }

    dataForCustomerCreate(formData: ICustomerCreate): IPersonCreate {
        return {
            firstName: formData.firstName,
            lastName: formData.lastName,
            phone: formData.phone,
            role: Role.customer,
        };
    }

    formCustomerData(): ICustomerCreate {
        return {
            firstName: this.data.firstName,
            lastName: this.data.lastName,
            phone: this.data.phone,
        };
    }

    //получаем начало и конец текущего рабочего дня из графика (формат строка)
    getStartWorkTime(currentDate: Date): string | null | undefined {
        return this.getScheduleTime(currentDate, 'startWorkTime');
    }

    getEndWorkTime(currentDate: Date): string | null | undefined {
        return this.getScheduleTime(currentDate, 'endWorkTime');
    }

    private getScheduleTime(currentDate: Date, timeType: 'startWorkTime' | 'endWorkTime'): string | null | undefined {
        if (!this.data.scheduleParams) {return;}
        const day = this.getDay(currentDate);
        return this.data.scheduleParams[day]?.[timeType];
    }

    getScheduleTimeDate(currentDate: Date, timeType: 'startWorkTime' | 'endWorkTime'): Date | null | undefined {
        const timeString = this.getScheduleTime(currentDate, timeType);
        return timeString ? this.getTime(timeString, currentDate) : undefined;
    }

    private getDay(date:Date):DaysKey {
        const dayOfWeek = date.getDay();
        return dayOfWeek === 0 ? 7 : (dayOfWeek as DaysKey);
    }

    private getTime(timeString:string, currentDate: Date):Date {
        const [hoursStr, minutesStr] = timeString.split(':');
        const hours = parseInt(hoursStr, 10);
        const minutes = parseInt(minutesStr, 10);
        const timeDate = new Date(currentDate);
        timeDate.setHours(hours);
        timeDate.setMinutes(minutes);
        return timeDate;
    }
}
